/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import type { ClientRuntimeConfig } from '../types';
import { API_BASE_URL, requestJson } from './httpClient';

const AGENT_CODE_REGEX = /^[a-z][a-z0-9_-]{2,31}$/;

const resolveClientAgentCode = () => {
  if (typeof window === 'undefined') return '';
  const params = new URLSearchParams(window.location.search || '');
  const raw = params.get('agentCode') || params.get('agent') || '';
  const text = raw.trim().toLowerCase();
  return AGENT_CODE_REGEX.test(text) ? text : '';
};

export const fetchClientRuntimeConfig = async () => {
  const agentCode = resolveClientAgentCode();
  const query = agentCode ? `?agentCode=${encodeURIComponent(agentCode)}` : '';
  return requestJson<ClientRuntimeConfig>(`${API_BASE_URL}/app-config${query}`, undefined, {
    skipAuth: true,
  });
};
